<div class="product-library">
  <mat-tab-group
    animationDuration="0ms"
    mat-align-tabs="start"
    mat-stretch-tabs="false"
    #tabGroup
    [(selectedIndex)]="selectedIndex"
    (selectedTabChange)="onTabChange()"
  >
    <mat-tab label="Glazing" class="tab-content">
      <app-glazing-list></app-glazing-list>
    </mat-tab>
    <mat-tab label="Shading" class="tab-content">
      <app-shading-list></app-shading-list>
    </mat-tab>
  </mat-tab-group>
</div>
